export default __webpack_public_path__ + "static/media/scrollerOne.6dc59247.png";